import React, { useState, useEffect } from "react";
import useSWR from "swr";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const LanguageApi = (props) => {
  var userLang = navigator.language || navigator.userLanguage;
  const language = cookies.get("language");
  const [langselection, setlangselection] = useState("en");
  useEffect(() => {
    if (!language) {
      setlangselection(userLang);
      cookies.set("language", userLang, { path: "/" });
    } else {
      setlangselection(language);
    }
  }, []);

  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "language.php?language=" + langselection,
  );
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;

  return {
    Corporate: data.Corporate,
    contact: data.contact,
    contact_go_subtitle: data.contact_go_subtitle,
    contanct_go: data.contanct_go,
    download_catalog: data.download_catalog,
    have_something_on_your_mind: data.have_something_on_your_mind,
    home: data.home,
    language_code: data.language_code,
    language_id: data.language_id,
    language: data.language,
    mail: data.mail,
    message: data.message,
    mission: data.mission,
    mission_text: data.mission_text,
    mission_title: data.mission_title,
    name: data.name,
    number: data.number,
    our_featured_products: data.our_featured_products,
    our_production_quality: data.our_production_quality,
    our_production_quality_text: data.our_production_quality_text,
    post: data.post,
    product: data.product,
    services: data.services,
    services_text: data.services_text,
    slogan: data.slogan,
    subject: data.subject,
    who_are_we: data.who_are_we,
    who_are_we_text: data.who_are_we_text,
    why_us: data.why_us,
    why_us_text: data.why_us_text,
    go: data.go,
    certificate: data.certificate,
    certificate_text: data.certificate_text,
    usagearea: data.usagearea,
    usage_text: data.usage_text,
    packageText: data.package,
    storage: data.storage,
    lifetime: data.lifetime,
  };
};

export default LanguageApi;
